import { NavLink, Link } from 'react-router-dom';
import styles from './Masthead.module.css';

export function Masthead() {
  return (
    <header className={styles.masthead}>
      <div className={`${styles.inner} container-wide`}>
        <Link to="/" className={styles.wordmarkLink} aria-label="ViBE — Vernacular Internet Behavioral Evaluation">
          <span className={styles.wordmark}>ViBE</span>
          <span className={styles.colon}>:</span>
          <span className={styles.expansion}>Vernacular Internet Behavioral Evaluation</span>
        </Link>

        <nav className={styles.nav} aria-label="Primary">
          <NavLink to="/" end className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`}>
            Leaderboard
          </NavLink>
          <NavLink to="/methodology" className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`}>
            Methodology
          </NavLink>
          <NavLink to="/paper" className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`}>
            Paper
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
